import React from "react";

export function ErrorWebRTC() {
  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <div className="text-center">
        <h1 className="font-weight-bold mb-4">
          WebRTC connection is failed or blocked
        </h1>
        <button
          className="btn btn-primary"
          onClick={() => window.location.reload()}
        >
          Reload Page
        </button>
      </div>
    </div>
  );
}
